import { TaskWithSub } from 'entities';

import { Tooltip, Tag, Row } from 'components/Blocks';
import { InfoIcon } from 'components/Icons';
import { EntityStatusTag } from 'components/Entities';

interface TaskHeaderProps {
  children?: never;
  task: TaskWithSub;
}

function TaskHeader({ task: { status, name, baseName, tags, id } }: TaskHeaderProps): JSX.Element {
  const nameDiff = name.trim().toLocaleLowerCase() !== baseName.trim().toLocaleLowerCase();

  return (
    <Row gap="3" flexWrap="wrap">
      <EntityStatusTag target="task" status={status} size="medium" round={false} />

      <h6 className="leading-none ">{name}</h6>

      {nameDiff && (
        <Tooltip content={baseName} clickable>
          <InfoIcon size={18} />
        </Tooltip>
      )}

      <Row>
        {tags?.map(({ tag }) => (
          <Tag className="text-white" size="medium" key={`task-tag-${tag.id}-${id}`} {...tag} />
        ))}
      </Row>
    </Row>
  );
}

export default TaskHeader;
